export const SUPER_ADMIN = 1;
export const ADMIN = 2;
export const UNIT_MANAGER = 3;
export const INVOICE_MANAGER = 4;
export const READ_ONLY = 5;
export const ACCOUNT_MANAGER = 6;
export const BRANCH_MANAGER = 8;
export const REGIONAL_MANAGER = 9;
export const ZONAL_MANAGER = 10;
export const ORDER_MANAGER = 11;
export const PAYMENT_MANAGER = 7;